import { createElementIdSlice } from '../utils/action/createElementSlice';
export const UnknownState = createElementIdSlice({
    elementName: 'unknown',
    initialState: {},
    reducers: {},
});
